(function () {
  if (window.milkwhiteAnnouncement) {
    window.milkwhiteAnnouncement.refresh();
    return;
  }

  const mobile = window.matchMedia('(max-width: 575.98px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const getBars = (root) => {
    if (root.matches && root.matches('.announcement-bar')) return [root];
    return root.querySelectorAll('.announcement-bar');
  };

  const destroy = (bar) => {
    const slide = bar.querySelector('.announcement-bar__slide');
    const slider = slide && slide.querySelector('.swiper');
    if (slider && slider.swiper && !slider.swiper.destroyed) {
      slider.swiper.destroy(true, true);
    }
    if (slide) slide.classList.remove('slider_started');
    bar.classList.remove('announcement__slide-show');
  };

  const refresh = (root = document) => {
    getBars(root).forEach((bar) => {
      const slide = bar.querySelector('.announcement-bar__slide');
      const slider = slide && slide.querySelector('.swiper');
      const speed = slide ? Number(slide.dataset.announcementSpeed) * 1000 : 0;
      const shouldAnimate = mobile.matches && !reducedMotion.matches &&
        Number.isFinite(speed) && speed > 0 && typeof Swiper === 'function';

      if (!slider || !shouldAnimate) {
        destroy(bar);
        return;
      }

      if (slider.swiper && !slider.swiper.destroyed) return;

      const slides = slider.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');
      if (slides.length < 2) {
        destroy(bar);
        return;
      }

      bar.classList.add('announcement__slide-show');
      new Swiper(slider, {
        slidesPerView: 'auto',
        speed: speed,
        initialSlide: 0,
        loop: true,
        loopedSlides: slides.length,
        allowTouchMove: true,
        watchSlidesProgress: false,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
          waitForTransition: true,
        },
      });
      slide.classList.add('slider_started');
    });
  };

  window.milkwhiteAnnouncement = { refresh: refresh };
  mobile.addEventListener('change', () => refresh());
  reducedMotion.addEventListener('change', () => refresh());

  document.addEventListener('shopify:section:load', (event) => refresh(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    getBars(event.target).forEach(destroy);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => refresh(), { once: true });
  } else {
    refresh();
  }
})();
